import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Konva from 'konva'
import { Stage, Layer, Rect, Image } from 'react-konva'
import { Position } from 'helpers/math'
import { updateCursor } from 'helpers/media'

export class Minimap extends Component
{
    static propTypes = {
        parentId: PropTypes.string.isRequired,
        sourceLoading: PropTypes.func.isRequired,
        sourceLoaded: PropTypes.func.isRequired,
        isSourceLoaded: PropTypes.bool.isRequired,
        id: PropTypes.string.isRequired,
        frame: PropTypes.object.isRequired,
        computeMinimapViewData: PropTypes.func.isRequired,
        isInvertActive: PropTypes.bool.isRequired,
        filters: PropTypes.object.isRequired,
        areFiltersApplied: PropTypes.bool.isRequired,
        scaleFactor: PropTypes.number.isRequired,
        zoomIn: PropTypes.func.isRequired,
        zoomOut: PropTypes.func.isRequired,
        minimapInteraction: PropTypes.func.isRequired,
    }

    constructor(props)
    {
        super(props)
        this.image = null

        this.loadImage = this.loadImage.bind(this)
        this.imageLoaded = this.imageLoaded.bind(this)
        this.filters = this.filters.bind(this)
        this.dragMove = this.dragMove.bind(this)
        this.zoom = this.zoom.bind(this)
        this.dragBoundFunc = this.dragBoundFunc.bind(this)
    }

    loadImage(location)
    {
        const { sourceLoading } = this.props

        sourceLoading()
        this.image = new window.Image()
        this.image.crossOrigin = "anonymous"
        this.image.src = location
        this.image.addEventListener("load", this.imageLoaded)
    }

    imageLoaded()
    {
        const { sourceLoaded, initProjection } = this.props

        initProjection()
        sourceLoaded()
    }

    filters()
    {
        const { isInvertActive } = this.props

        const filters = [Konva.Filters.Brighten, Konva.Filters.Contrast]
        if(isInvertActive)
        {
            filters.push(Konva.Filters.Invert)
        }

        return filters
    }

    dragMove(event)
    {
        this.props.minimapInteraction()
        updateCursor('grabbing')(event)
    }

    zoom(delta)
    {
        if(delta < 0) return this.props.zoomIn()

        return this.props.zoomOut()
    }

    dragBoundFunc(pos)
    {
        const { updateImageReferencePosition, scaleFactor, computeMinimapViewData } = this.props
        const currentPosition = new Position(pos.x, pos.y)
        const currentViewingWindow = computeMinimapViewData().viewingWindow

        updateImageReferencePosition(scaleFactor, currentViewingWindow.position.createVector(currentPosition).invert())

        const updatedViewingWindow = computeMinimapViewData().viewingWindow

        return updatedViewingWindow.position
    }

    componentDidMount()
    {
        this.loadImage(this.props.location.original)
    }

    componentWillReceiveProps(nextProps)
    {
        if(nextProps.rotation !== this.props.rotation)
        {
            this.props.initProjection()
        }
    }

    componentDidUpdate()
    {
        if(! this.props.isSourceLoaded || ! this.imageNode)
        {
            return
        }

        const { areFiltersApplied } = this.props
        this.imageNode.clearCache()

        if(areFiltersApplied)
        {
            this.imageNode.cache()
        }

        this.imageNode.getLayer().batchDraw()
    }

    render()
    {
        if(! this.props.isSourceLoaded)
        {
            return null
        }

        const { rotation, frame, computeMinimapViewData, filters: { brightness, contrast } } = this.props
        const minimapView = computeMinimapViewData()
        const { image, viewingWindow } = minimapView

        return (
            <Stage
                width={frame.width}
                height={frame.height}
                onWheel={(event) => this.zoom(event.evt.deltaY)}
            >
                <Layer>
                    <Image
                        ref={node => this.imageNode = node}
                        image={this.image}
                        width={image.width}
                        height={image.height}
                        rotation={rotation}
                        offset={{
                            x: image.width / 2,
                            y: image.height / 2,
                        }}
                        position={{
                            x: frame.width / 2,
                            y: frame.height / 2,
                        }}
                        filters={this.filters()}
                        brightness={brightness}
                        contrast={contrast}
                    />
                </Layer>
                <Layer>
                    <Rect
                        width={image.width}
                        height={image.height}
                        rotation={rotation}
                        offset={{
                            x: image.width / 2,
                            y: image.height / 2,
                        }}
                        position={{
                            x: frame.width / 2,
                            y: frame.height / 2,
                        }}
                        fill={'rgba(32, 39, 43, 0.7)'}
                    />
                    <Rect
                        width={viewingWindow.width}
                        height={viewingWindow.height}
                        offset={viewingWindow.offset}
                        position={viewingWindow.position}
                        fill={'rgba(0, 0, 0, 1)'}
                        globalCompositeOperation={'destination-out'}
                        draggable={true}
                        dragBoundFunc={this.dragBoundFunc}
                        onDragMove={this.dragMove}
                        onDragend={updateCursor('grab')}
                        onMouseover={updateCursor('grab')}
                        onMouseout={updateCursor('default')}
                    />
                </Layer>
            </Stage>
        )
    }
}
